import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { Navigate } from "react-router-dom";
import { App as CapacitorApp } from '@capacitor/app';

import LoginScreen from './pages/LoginScreen';
import RegisterScreen from './pages/RegisterScreen';
import ActivateScreen from './pages/ActivateScreen';
import DeleteAccountScreen from './pages/DeleteAccountScreen';
import LoginRedirect from './pages/login';
import AppShell from './AppShell';
import ProtectedRoute from './components/Shared/ProtectedRoute';

function BackButtonHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    let removeListener = null;

    // Only attach listener if running inside Capacitor AND on a real device
    const isNative = typeof window !== "undefined" && window.Capacitor && window.Capacitor.isNativePlatform();

    if (!isNative) {
      return; // Skip listener on web
    }

    (async () => {
      const listener = await CapacitorApp.addListener('backButton', ({ canGoBack }) => {
        if (window.closeAnyModal && window.closeAnyModal()) return;
        if (window.closeAnyDrawer && window.closeAnyDrawer()) return;
        if (window.closeAnySidebar && window.closeAnySidebar()) return;

        if (canGoBack) {
          navigate(-1);
          return;
        }

        CapacitorApp.exitApp();
      });

      removeListener = listener.remove?.bind(listener);
    })();

    return () => {
      if (removeListener && typeof removeListener === "function") {
        removeListener();
      }
    };
  }, [navigate]);

  return null; // this component renders nothing
}

export default function App() {
  return (
    <Router>
      {/* Back-button listener is active globally */}
      <BackButtonHandler />

      <Routes>
        <Route path="/" element={<Navigate to="/auth/login" replace />} />
        <Route path="/login" element={<LoginRedirect />} />
        <Route path="/auth/login" element={<LoginScreen />} />
        <Route path="/register" element={<RegisterScreen />} />
        <Route path="/activate" element={<ActivateScreen />} />
        <Route path="/delete-account" element={<DeleteAccountScreen />} />

        <Route
          path="*"
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}